import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var InfoCircle = function InfoCircle(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#573AE6' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2.4rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Info icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 24 24",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: color,
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.2747C13 9.75487 12.5523 9.3335 12 9.3335C11.4477 9.3335 11 9.75487 11 10.2747V17C11 17.5198 11.4477 18 12 18C12.5523 18 13 17.5198 13 17V10.2747Z",
    fill: color
  }));
};

export default InfoCircle;